import Vue from 'vue';
import Router from 'vue-router';
import StudentSelection from '@/components/students/StudentSelection';
import TestExecution from '@/components/tests/TestExecution';
import Home from '@/components/Home';
import NoTest from '@/components/NoTest';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', component: NoTest },
    { path: '/:code', component: Home },
    { path: '/student/select', component: StudentSelection },
    { path: '/test/execute', component: TestExecution },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js